

















import { defineComponent, computed, SetupContext } from '@vue/composition-api'
import moment from 'moment'

import { IReceipt, supplierName } from '@/types/receipt'
import { getReceiptType, receiptTypeToDisplayName } from '@/utils/mapper'

type Props = {
  receipts: IReceipt[]
  total: number
  loading: boolean
}

export default defineComponent({
  name: 'ContributersTable',
  props: {
    receipts: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props: Props, context: SetupContext) {
    const store = context.root.$store

    const headers = [
      { text: 'レシートID', value: 'id' },
      { text: 'サービス名', value: 'supplier' },
      { text: '投稿者ID', value: 'monitorId' },
      { text: '投稿日時', value: 'postedAt' },
      { text: '性別', value: 'monitorGender' },
      { text: '年齢', value: 'monitorAge' },
      { text: '都道府県', value: 'monitorPrefecture' },
      { text: 'チェーン店名', value: 'shop.name' },
      { text: '購入日', value: 'dateTime' },
      { text: 'レシートステータス', value: 'receiptType' },
    ]
    const items = computed(() =>
      props.receipts.map(receipt => {
        return {
          ...receipt,
          supplier: supplierName(receipt.supplier),
          monitorGender:
            receipt.monitorGender === 'male'
              ? '男性'
              : receipt.monitorGender === 'female'
              ? '女性'
              : '不明',
          monitorAge: receipt.monitorAge ? receipt.monitorAge : '-',
          postedAt: moment(receipt.postedAt).format('YYYY/MM/DD HH:mm'),
          dateTime: receipt.dateTime
            ? moment(receipt.dateTime).format('YYYY/MM/DD HH:mm')
            : '-',
          receiptType: receiptTypeToDisplayName(getReceiptType(receipt)),
        }
      }),
    )

    const onClickEditButton = async (
      item: Record<string, string | boolean>,
    ) => {
      const receipt = await store.dispatch(
        'receipt/getReceiptWithReProcess',
        item.id,
      )
      await store.dispatch('receipt/setReceipts', [[receipt], 1])
      await store.dispatch('receipt/setReceiptType', getReceiptType(receipt))
      context.root.$router.push('/ocr').catch(() => {
        /*2連打した際のerrorを無視*/
      })
    }

    return { headers, items, onClickEditButton }
  },
})
